import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import PageTransition from "./components/PageTransition";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import NotFoundPage from "./pages/NotFoundPage";
import PhotographyPage from "./pages/PhotographyPage";
import WorkPage from "./pages/WorkPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (process.env.NODE_ENV === "test") return;
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <PageTransition />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/photography" element={<PhotographyPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
